/**
 * Helper to get the dom rect from a react ref.
 */
export const domRect = ref => {
  return ref && ref.current && ref.current.getBoundingClientRect();
};
